export default {
  GRID: 'grid',
  LIST: 'list',
};
